import {Component} from 'react'
import {BsSearch} from 'react-icons/bs'
import Cookies from 'js-cookie'

import Navbar from '../Navbar'
import BookShelfItems from '../BookShelfItems'
import BookItem from '../BookItem'
import {Container, ShelvesContainer} from './StyledComponents'
import ThemeContext from '../../Context/ThemeContext'

import './index.css'

const bookshelvesList = [
  {
    id: '22526c8e-680e-4419-a041-b05cc239ece4',
    value: 'ALL',
    label: 'All',
  },
  {
    id: '37e09397-fab2-46f4-9b9a-66b2324b2e22',
    value: 'READ',
    label: 'Read',
  },
  {
    id: '2ab42512-3d05-4fba-8191-5122175b154e',
    value: 'CURRENTLY_READING',
    label: 'Currently Reading',
  },
  {
    id: '361d5fd4-9ea1-4e0c-bd47-da2682a5b7c8',
    value: 'WANT_TO_READ',
    label: 'Want to Read',
  },
]

class BookShelves extends Component {
  state = {
    activeShelf: bookshelvesList[0].value,
    inputSearch: '',
    booksList: [],
  }

  componentDidMount() {
    this.getBooks()
  }

  getBooks = async () => {
    const {activeShelf, inputSearch} = this.state
    const jwtToken = Cookies.get('jwt_token')
    const getBooksUrl = `https://apis.ccbp.in/book-hub/books?shelf=${activeShelf}&search=${inputSearch}`
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
    const response = await fetch(getBooksUrl, options)
    const data = await response.json()
    const {books} = data
    const convertedBooks = books.map(each => this.convertToCamelCase(each))
    this.setState({booksList: convertedBooks})
  }

  convertToCamelCase = book => ({
    id: book.id,
    title: book.title,
    authorName: book.author_name,
    coverPic: book.cover_pic,
    rating: book.rating,
    readStatus: book.read_status,
  })

  onChangeActiveShelf = value => {
    this.setState({activeShelf: value}, this.getBooks)
  }

  onChangeInput = event => {
    this.setState({inputSearch: event.target.value}, this.getBooks)
  }

  renderDisplayBooks = () => {
    const {booksList} = this.state
    return booksList.map(each => <BookItem key={each.id} bookDetails={each} />)
  }

  render() {
    const {activeShelf, inputSearch} = this.state
    const activeShelfDetails = bookshelvesList.filter(
      each => each.value === activeShelf,
    )
    const activeShelfLabel = activeShelfDetails[0].label

    return (
      <>
        <Navbar />
        <ThemeContext.Consumer>
          {value => {
            const {theme} = value
            return (
              <Container isDark={theme} className="book-shelf-bg-container">
                <div className="shelves-list">
                  <ShelvesContainer isDark={theme} as="ul">
                    <h1 className="book-shelves-heading1">Bookshelves</h1>
                    {bookshelvesList.map(each => (
                      <BookShelfItems
                        key={each.id}
                        shelf={each}
                        activeShelf={activeShelf}
                        onChangeActiveShelf={this.onChangeActiveShelf}
                      />
                    ))}
                  </ShelvesContainer>
                </div>
                <div className="books-list-bg-container">
                  <div className="books-list-top-container">
                    <h1 className="selected-books-heading">
                      {activeShelfLabel} Books
                    </h1>
                    <div className="input-container">
                      <input
                        value={inputSearch}
                        onChange={this.onChangeInput}
                        className="book-search-input"
                        type="text"
                        placeholder="search"
                      />
                      <button type="button" className="search-logo-btn">
                        <BsSearch
                          className="search-logo"
                          color="#7D8389"
                          size={14}
                        />
                      </button>
                    </div>
                  </div>
                  <h1 className="book-shelves-heading2">Bookshelves</h1>
                  <ul className="shelves-list2">
                    {bookshelvesList.map(each => (
                      <BookShelfItems
                        key={each.id}
                        shelf={each}
                        activeShelf={activeShelf}
                        onChangeActiveShelf={this.onChangeActiveShelf}
                      />
                    ))}
                  </ul>
                  <ul className="u-list">{this.renderDisplayBooks()}</ul>
                </div>
              </Container>
            )
          }}
        </ThemeContext.Consumer>
      </>
    )
  }
}

export default BookShelves
